import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { Tooltip } from '@material-ui/core';
import { CustomFieldsOptionsFieldDef } from '../../data/data';

export class CustomFieldsSuggestions extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'CustomFields'
    this.pageTitle = Helper.getString('suggestions')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.uploadLocation = this.orgId
    this.deviceCfId = this.props.match.params.id
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('customField'), to: this.baseRoute() + '/custom-fields' },
      { title: Helper.getString('suggestions') },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['devicecfs',this.deviceCfId], queryParams: { groupId: this.orgId, pb: 'fieldDefCfSuggestions' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.addNewLabel = 'Add Suggestion'
    this.noTableHead = true
    this.allowAccessToRoles = ['VENUES']
    if(!UiHelper.isUserHasRoles(this.allowAccessToRoles)) this.noAdd = true
  }

  formatSuggestionResult(inputObject) {
    const resultArray = Object.values(inputObject).map(item => ({
      id: item.id,
      title: item.title
    }));

    return resultArray.reverse();
  }

  onFetchSuccess(results) {
    this.pageTitle = results[0].title || Helper.getString('suggestions')
    this.formDefinition = this.fieldDef = results[0].fieldDefCfSuggestions
    for (const f of results[0].fieldDefCfSuggestions.steps[0].fields) {
      if(f.key === 'title') {
        f.label = Helper.getString('suggestionFieldLabel')
      }
    }
    this.setState({
      items: this.formatSuggestionResult(results[0].suggestions)
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAttrName: 'suggestions', entityAction: 'add' },
      apiEndPoint: ApiHelper.makeUrlPath(['devicecfs', this.deviceCfId]),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAttrName: 'suggestions', entityAction: 'del', id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['devicecfs', this.deviceCfId]),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAttrName: 'suggestions', entityAction: 'edit', id: current.id},
      apiEndPoint: ApiHelper.makeUrlPath(['devicecfs', this.deviceCfId]),
    });
  }

  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonDelete(this, current), this.allowAccessToRoles)
    return actions
  }

}

const Styles = StyleSheet.create({
  actionIconImage:{
    width: 20,
    height: 20
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/CustomFieldsSuggestions.js